import { BaseResource } from '@/modules/core/app/resources/BaseResource';
import { StripeCoupon } from '@/modules/billing/models/stripe/StripeCoupon';
import { Route } from '@/modules/core/app/constants/api.constants';

export class StripeCouponResource extends BaseResource {
  getCoupon(couponId: string, params?: Params): StripeCoupon {
    return this.getData(`${Route.STRIPE_COUPONS}/${couponId}`, StripeCoupon, params);
  }
}

export default new StripeCouponResource();
